import { Link } from "react-router-dom";
import { X as XIcon } from "lucide-react";
import { Button } from "./ui/button";

export function MobileMenu({ isOpen, onClose, user, onLogout, isOwner, isAdmin, toggleLoginPopup }) {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[49] lg:hidden transition-opacity duration-300"
        onClick={onClose}
      />
      <div 
        className={`fixed left-0 top-0 h-full w-64 bg-white/95 backdrop-blur-sm transform transition-transform duration-300 ease-in-out z-[50] lg:hidden shadow-xl
          ${isOpen ? 'translate-x-0 animate-slideInLeft' : '-translate-x-full animate-slideOutLeft'}`}
      >
        <div className="h-[64px] px-4 flex bg-black justify-between items-center border-b"> {/* Fixed height */}
          <h2 className="text-base text-white font-semibold">Menu</h2> {/* Adjusted text size */}
          <Button variant="ghost" size="sm" onClick={onClose} className="hover:bg-transparent">
            <XIcon className="h-5 w-5 text-white" /> {/* Adjusted icon size */}
          </Button>
        </div>
        <nav className="mt-6">
          <div className="px-4 space-y-2">
            <Link
              to="/for-owner"
              className="block py-2 px-4 hover:bg-gray-100 rounded transition duration-300"
              onClick={onClose}
            >
              For House Owners
            </Link>
            <Link
              to="/wishlists"
              className="block py-2 px-4 hover:bg-gray-100 rounded transition duration-300"
              onClick={onClose}
            >
              Wishlists
            </Link>
            {isAdmin && (
              <Link
                to="/admin"
                className="block py-2 px-4 hover:bg-gray-100 rounded transition duration-300"
                onClick={onClose}
              >
                Admin Dashboard
              </Link>
            )}
            {user && (
              <Link
                to="/profile"
                className="block py-2 px-4 hover:bg-gray-100 rounded transition duration-300"
                onClick={onClose}
              >
                Profile
              </Link>
            )}
            {isOwner && (
              <Link
                to="/owner"
                className="block py-2 px-4 hover:bg-gray-100 rounded transition duration-300"
                onClick={onClose}
              >
                Owner Dashboard
              </Link>
            )}
            {user ? (
              <button
                onClick={() => {
                  onLogout();
                  onClose();
                }}
                className="w-full text-left py-2 px-4 hover:bg-gray-100 rounded transition duration-300"
              >
                Logout
              </button>
            ) : (
              <button
                onClick={() => {
                  toggleLoginPopup(true);
                  onClose();
                }}
                className="w-full text-left py-2 px-4 hover:bg-gray-100 rounded transition duration-300"
              >
                Login
              </button>
            )}

            <div className="mt-8">
              <h3 className="font-bold mb-2 px-4">About us</h3>
              <ul className="space-y-1">
                <li>
                  <a href="#" className="block py-1 px-4 hover:bg-gray-100 rounded transition duration-300">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="#" className="block py-1 px-4 hover:bg-gray-100 rounded transition duration-300">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="#" className="block py-1 px-4 hover:bg-gray-100 rounded transition duration-300">
                    Support
                  </a>
                </li>
                <li>
                  <a href="#" className="block py-1 px-4 hover:bg-gray-100 rounded transition duration-300">
                    Help
                  </a>
                </li>
              </ul>
            </div>

            <div className="mt-4">
              <h3 className="font-bold mb-2 px-4">Social</h3>
              <ul className="space-y-1">
                <li>
                  <a href="#" className="block py-1 px-4 hover:bg-gray-100 rounded transition duration-300">
                    Instagram
                  </a>
                </li>
                <li>
                  <a href="#" className="block py-1 px-4 hover:bg-gray-100 rounded transition duration-300">
                    Whatsapp
                  </a>
                </li>
                <li>
                  <a href="#" className="block py-1 px-4 hover:bg-gray-100 rounded transition duration-300">
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}